import { apiCall, apiCallAdmin } from "../../services/api-service";

export const getFAQListApi = async () => {
  const response = await apiCallAdmin("get", "help?application=MeetQ");
  return response.data;
};

export const reportAnIssueApi = async (data) => {
  const response = await apiCallAdmin("post", "report_issue", data);
  return response;
};

export const getReportIssueTypeApi = async () => {
  const response = await apiCallAdmin("get", "get_issue_type");
  return response.data;
};

export const getProfileDetailsApi = async () => {
  const response = await apiCallAdmin("get", "basicprofile");
  return response;
};

export const getOrgLogoApi = async () => {
  const response = await apiCallAdmin("get", "get_org_image");
  return response.data;
};

export const getDeleteApi = async (deleteUrl) => {
  const response = await apiCall("delete", deleteUrl);
  return response;
};
export const updateProfileImageApi = async (data) => {
  const response = await apiCallAdmin("post", "user/image_update", data);
  return response;
};
export const getOrgListApi = async () => {
  const response = await apiCallAdmin("get", "get_enrolled_orgs");
  return response;
};

export const getSwitchAccountApi = async (id) => {
 const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";
  return await apiCallAdmin("GET", isHttpsOnly ? `switch_org_http_only/${id}` : `switch_org/${id}`);
 
};
